import {
  relewiseFallback,
  relewiseTags,
  searchEvents
} from '@/shared/constants/constants';
import { deepQuerySelectorAll } from '@/shared/tracking/shadow-dom';
import type { RelewiseFailureReason } from '@/shared/utils/relewise-fallback-reason';

export type NativeHeaderSwappedDetail = {
  focusInputId: string | null;
};

const findRelewiseHeader = (): HTMLElement | null =>
  document.querySelector<HTMLElement>(
    relewiseFallback.RELEWISE_FORM_SELECTOR
  ) ?? document.querySelector<HTMLElement>(relewiseTags.OVERLAY_TAG);

const readTypedTerm = (header: HTMLElement): string =>
  deepQuerySelectorAll(header, 'input')
    .map((el) => (el instanceof HTMLInputElement ? el.value.trim() : ''))
    .find(Boolean) ?? '';

export const swapHeaderToNative = (reason: RelewiseFailureReason): boolean => {
  const template = document.querySelector<HTMLTemplateElement>(
    relewiseFallback.NATIVE_TEMPLATE_SELECTOR
  );
  if (!template || document.getElementById(relewiseFallback.NATIVE_HEADER_ID)) {
    return false;
  }

  const header = findRelewiseHeader();
  const nativeForm = template.content.firstElementChild?.cloneNode(true);
  if (!header || !(nativeForm instanceof HTMLElement)) {
    return false;
  }

  nativeForm.dataset[relewiseFallback.FALLBACK_REASON_ATTRIBUTE] = reason;

  const term = readTypedTerm(header);
  if (term) {
    nativeForm.dataset.searchTerms = term;
    const nativeInput = nativeForm.querySelector<HTMLInputElement>(
      relewiseFallback.NATIVE_INPUT_SELECTOR
    );
    if (nativeInput) {
      nativeInput.value = term;
    }
  }

  const hadFocus = header.contains(document.activeElement);

  header.replaceWith(nativeForm);
  template.remove();

  window.dispatchEvent(
    new CustomEvent<NativeHeaderSwappedDetail>(
      searchEvents.NATIVE_HEADER_SWAPPED,
      {
        detail: {
          focusInputId: hadFocus ? (nativeForm.dataset.inputId ?? null) : null
        }
      }
    )
  );
  return true;
};
